import { LINK_EXPIRATION_MANAGEMENT_URL } from 'modules/linkExpirationManagement/constants';
import { ModalAction, ModalState } from 'modules/linkExpirationManagement/types';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Prompt, useHistory } from 'react-router';
import { useModalContext } from 'utils/contexts/modal';

export const UnsavedChangesPrompt = ({ shouldNavigate }: { shouldNavigate: boolean }) => {
  /** save next location from Prompt to pass through user action */
  const [nextLocation, setNextLocation] = useState('');
  /** What about Angular routes? */
  const history = useHistory();
  const { showModal } = useModalContext<ModalState>();
  const {
    formState: { isDirty },
  } = useFormContext();

  useEffect(() => {
    if (shouldNavigate) {
      history.push(nextLocation);
    }
  }, [nextLocation, shouldNavigate]);

  return (
    <Prompt
      message={(location) => {
        const isNewURL = !location.pathname.includes(LINK_EXPIRATION_MANAGEMENT_URL);
        if (isDirty && isNewURL) {
          setNextLocation(location.pathname);
          showModal({ action: ModalAction.UNSAVED_CHANGES });
          return false;
        }
        return true;
      }}
      when={!!isDirty && !shouldNavigate}
    />
  );
};
